import React, { useEffect, useState } from "react";

//jquery
import $ from "jquery";

//dayjs
import dayjs from "dayjs";

//redux
import { connect, useSelector } from "react-redux";

//action
import { coinPlanHistory } from "../../store/coinPlan/action";

//pagination
import Pagination from "../../pages/Pagination";

//MUI icon
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

//Date Range Picker
import { DateRangePicker } from "react-date-range";
//Calendar Css
import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

//routing
import { Link } from "react-router-dom";

import PurchaseCoinPlan from "./history/PurchaseCoinPlan";

const PurchaseCoinPlanTable = (props) => {
  const [data, setData] = useState([]);
  const [activePage, setActivePage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(2);

  const [date, setDate] = useState([]);
  const [sDate, setsDate] = useState("ALL");
  const [eDate, seteDate] = useState("ALL");
  const { history, totalPlan } = useSelector((state) => state.coinPlan);

  const maxDate = new Date();

  useEffect(() => {
    $("#card").click((e) => {
      if (
        !$(e.target).closest(".rdrDateRangePickerWrapper").length &&
        !$(e.target).closest(".rdrDateInput").length
      ) {
        $("#datePicker").css("display", "none");
      }
    });
  }, []);

  useEffect(() => {
    props.coinPlanHistory(null, activePage, rowsPerPage, sDate, eDate);
  }, [activePage, rowsPerPage]);

  useEffect(() => {
    setData(history);
  }, [history]);

  useEffect(() => {
    if (date.length === 0) {
      const today = new Date();
      const firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
      const lastDay = new Date(today.getFullYear(), today.getMonth() + 1, 0);

      setDate([
        {
          startDate: firstDay,
          endDate: lastDay,
          key: "selection",
        },
      ]);

      // Set initial date range for API
      const dayStart = dayjs(firstDay).format("M/DD/YYYY");
      const dayEnd = dayjs(lastDay).format("M/DD/YYYY");
      setsDate(dayStart);
      seteDate(dayEnd);
    }
    $("#datePicker").css("display", "none");
    setData(history);
  }, [history]);

  const handlePageChange = (pageNumber) => {
    setActivePage(pageNumber);
  };

  const handleRowsPerPage = (value) => {
    setActivePage(1);
    setRowsPerPage(value);
  };

  const getAllHistory = () => {
    setActivePage(1);
    setsDate("ALL");
    seteDate("ALL");
    $("#datePicker").css("display", "none");
    props.coinPlanHistory(null, activePage, rowsPerPage, sDate, eDate);
  };

  const collapsedDatePicker = () => {
    const datePicker = $("#datePicker");
    if (datePicker.css("display") === "none") {
      datePicker.css("display", "block");
    } else {
      datePicker.css("display", "none");
    }
  };

  const handleDateFilter = () => {
    setActivePage(1);
    props.coinPlanHistory(null, 1, rowsPerPage, sDate, eDate);
    $("#datePicker").css("display", "none");
  };

  return (
    <>
      <div className="page-title">
        {props.type !== "coinPlanHistory" && (
          <div className="row">
            <div className="col-12 col-md-6 order-md-1 order-last">
              <h3 className="mb-3 text-white">Purchase Coin Plan History</h3>
            </div>
            <div className="col-12 col-md-6 order-md-2 order-first">
              <nav
                aria-label="breadcrumb"
                className="breadcrumb-header float-start float-lg-end"
              >
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin/dashboard" className="text-white">
                      Dashboard
                    </Link>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Plan
                  </li>
                </ol>
              </nav>
            </div>
          </div>
        )}
      </div>

      {/* ── FILTER BAR ── */}
      <div className="row mb-3">
        <div className="col-12">
          <div className="filter-bar">
            <div className="d-flex align-items-center gap-2 flex-wrap">
              <button
                className="edit-btn"
                style={{ marginRight: 5 }}
                onClick={getAllHistory}
              >
                All
              </button>
              <button
                className="edit-btn"
                value="check"
                data-toggle="show"
                data-target="#datePicker"
                onClick={collapsedDatePicker}
              >
                Analytics
                <ExpandMoreIcon style={{ fontSize: 18, marginLeft: 4 }} />
              </button>
              <p style={{ paddingLeft: 10 }} className="my-2 text-secondary">
                {sDate !== "ALL" && sDate + " to " + eDate}
              </p>
            </div>

            {/* Date picker */}
            <div
              id="datePicker"
              className="date-picker-wrapper mt-3"
              aria-expanded="false"
              style={{ display: "none" }}
            >
              <div className="container table-responsive">
                <div key={JSON.stringify(date)}>
                  <DateRangePicker
                    maxDate={maxDate}
                    onChange={(item) => {
                      setDate([item.selection]);
                      const dayStart = dayjs(item.selection.startDate).format(
                        "M/DD/YYYY",
                      );
                      const dayEnd = dayjs(item.selection.endDate).format(
                        "M/DD/YYYY",
                      );
                      setsDate(dayStart);
                      seteDate(dayEnd);
                    }}
                    showSelectionPreview={true}
                    moveRangeOnFirstSelection={false}
                    ranges={date}
                    direction="horizontal"
                    editableDateInputs={true}
                  />
                  {sDate !== "ALL" && (
                    <div className="mt-3">
                      <button className="edit-btn" onClick={handleDateFilter}>
                        Apply Filter
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* ── TABLE CARD ── */}
      <div className="row mt-4">
        <div className="col">
          <div className="table-card" id="card">
            <div className="table-card-body">
              <PurchaseCoinPlan data={data} />
              <Pagination
                activePage={activePage}
                rowsPerPage={rowsPerPage}
                userTotal={totalPlan}
                handleRowsPerPage={handleRowsPerPage}
                handlePageChange={handlePageChange}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default connect(null, { coinPlanHistory })(PurchaseCoinPlanTable);
